import React from 'react';

const Delete = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.77694 19.9443C8.32953 19.9443 7.94653 19.785 7.62793 19.4664C7.30931 19.1478 7.15 18.7648 7.15 18.3174V6.89419H6.925C6.73375 6.89419 6.57344 6.82947 6.44406 6.70004C6.31469 6.57061 6.25 6.41023 6.25 6.21889C6.25 6.02756 6.31469 5.86729 6.44406 5.73806C6.57344 5.60882 6.73375 5.5442 6.925 5.5442H10.3C10.3 5.32381 10.3776 5.13603 10.5328 4.98084C10.688 4.82564 10.8758 4.74805 11.0961 4.74805H14.9039C15.1242 4.74805 15.312 4.82564 15.4672 4.98084C15.6224 5.13603 15.7 5.32381 15.7 5.5442H19.075C19.2662 5.5442 19.4266 5.60892 19.5559 5.73835C19.6853 5.86779 19.75 6.02817 19.75 6.2195C19.75 6.41084 19.6853 6.57113 19.5559 6.70035C19.4266 6.82958 19.2662 6.89419 19.075 6.89419H18.85V18.3174C18.85 18.7648 18.6907 19.1478 18.3721 19.4664C18.0535 19.785 17.6705 19.9443 17.2231 19.9443H8.77694ZM10.6635 16.7943H12.0135V8.69422H10.6635V16.7943ZM13.9865 16.7943H15.3365V8.69422H13.9865V16.7943Z"
        fill="#5C6983"
      />
    </svg>
  );
};

export default Delete;
